import React from "react";
import pdf from './resources/pdf.pdf';

import BasePdf from "../Base/pdf";

const InnovativeModulePdf = () => {
    return <BasePdf
        pdf={pdf}
    >
        I . MÁTE INOVATIVNÍ NÁPAD<br/>
        <br/>
        JAK TO TEDY JE?<br/>
        <br/>
        Každý, kdo přijde na něco nového, by se měl přesvědčit o tom, zda se může opravdu jednat o jedinečné řešení – o
        vynález. Více podmínek nám určuje národní legislativa – v případě Česka je to zákon č . 527/1990 Sb., o
        vynálezech a zlepšovacích návrzích. Podívejme se, co říká o vynálezech v paragrafech 2 až 8 .<br/>
        PATENT NA VYNÁLEZ<br/>
        § 2<br/>
        Na vynálezy, které splňují podmínky stanovené tímto zákonem, uděluje Úřad průmyslového vlastnictví (dále jen
        "Úřad") patenty.<br/>
        § 3<br/>
        Patentovatelnost vynálezů<br/>
        (1 ) Patenty se udělují na vynálezy, které jsou nové, jsou výsledkem vynálezecké činnosti a jsou průmyslově
        využitelné.<br/>
        (2 ) Za vynálezy se nepovažují zejména<br/>
        a ) objevy, vědecké teorie a matematické metody;<br/>
        b ) estetické výtvory;<br/>
        c ) plány, pravidla a způsoby vykonávání duševní činnosti, hraní her nebo vykonávání obchodní činnosti, jakož i
        programy počítačů;<br/>
        d ) podávání informací.<br/>
        (3 ) Patentovatelnost předmětů nebo činností uvedených v odstavci 2 je vyloučena za předpokladu, že se přihláška
        vynálezu nebo patent týkají pouze těchto předmětů nebo činností.<br/>
        (4 ) Způsoby chirurgického nebo terapeutického ošetřování lidského nebo zvířecího těla a diagnostické metody
        používané na lidském nebo zvířecím těle se nepovažují za průmyslově využitelné vynálezy ve smyslu odstavce 1 .
        Toto ustanovení se nevztahuje na výrobky, zejména látky nebo směsi, určené k použití při těchto způsobech
        ošetřování a při těchto diagnostických metodách.<br/>
        <br/>
        § 4<br/>
        Výluky z patentovatelnosti<br/>
        Patenty se neudělují:<br/>
        a ) na vynálezy, jejichž využití by se příčilo veřejnému pořádku nebo dobrým mravům; to nelze vyvodit pouze z
        toho, že využití vynálezu je zakázáno právním předpisem;<br/>
        b ) na odrůdy rostlin a plemena zvířat nebo v zásadě biologické způsoby pěstování rostlin či chovu zvířat; toto
        ustanovení neplatí pro mikrobiologické způsoby a výrobky těmito způsoby získané.<br/>
        § 5<br/>
        Novost<br/>
        (1 ) Vynález je nový, není-li součástí stavu techniky.<br/>
        (2 ) Stavem techniky je vše, k čemu byl přede dnem, od něhož přísluší přihlašovateli právo přednosti (§ 27),
        umožněn přístup veřejnosti písemně, ústně, využíváním nebo jiným způsobem.<br/>
        (3 ) Stavem techniky je i obsah přihlášek vynálezů podaných v České republice s dřívějším právem přednosti,
        pokud budou v den, od něhož přísluší přihlašovateli právo přednosti, nebo po tomto dni zveřejněny (§ 31). To
        platí i pro mezinárodní přihlášky vynálezů s dřívějším právem přednosti, v nichž je Úřad určeným úřadem,1a) a
        evropské patentové přihlášky (§ 35a) s dřívějším právem přednosti, u nichž je platně určeným státem Česká
        republika. Přihlášky vynálezů utajované podle zvláštních předpisů se pokládají pro účely tohoto ustanovení za
        zveřejněné uplynutím 18 měsíců od vzniku práva přednosti.<br/>
        (4 ) Ustanovení odstavců 1 až 3 nevylučují patentovatelnost použití látky nebo směsi při způsobech uvedených v §
        3 odst. 4 , pokud její použití při těchto způsobech není součástí stavu techniky.<br/>
        (5 ) Stavem techniky není takové zveřejnění vynálezu, ke kterému nedošlo dříve než šest měsíců před podáním
        přihlášky vynálezu a které přímo nebo nepřímo vyplývá<br/>
        a ) ze zřejmého zneužití vzhledem k přihlašovateli nebo k jeho právnímu předchůdci,<br/>
        b ) ze skutečnosti, že přihlašovatel nebo jeho právní předchůdce vystavil vynález na úřední nebo úředně uznané
        výstavě podle mezinárodní smlouvy.1 )<br/>
        V tomto případě je přihlašovatel povinen při podání přihlášky vynálezu uvést, že vynález byl vystaven a do čtyř
        měsíců po podání přihlášky vynálezu doložit osvědčením, že vynález byl vystaven podle mezinárodní smlouvy.<br/>
        § 6<br/>
        Vynálezecká činnost<br/>
        (1 ) Vynález je výsledkem vynálezecké činnosti, jestliže pro odborníka nevyplývá zřejmým způsobem ze stavu
        techniky.<br/>
        (2 ) Pro hodnocení vynálezecké činnosti však není rozhodný obsah přihlášek vynálezů, které ke dni, od něhož
        přísluší přihlašovateli právo přednosti, nebyly zveřejněny (§ 31).<br/>
        § 7<br/>
        Průmyslová využitelnost<br/>
        Vynález se považuje za průmyslově využitelný, může-li jeho předmět být vyráběn nebo jinak využíván v průmyslu,
        zemědělství nebo jiných oblastech hospodářství.<br/>
        § 8<br/>
        Právo na patent<br/>
        (1 ) Právo na patent má původce vynálezu nebo jeho právní nástupce.<br/>
        (2 ) Původcem vynálezu je ten, kdo jej vytvořil vlastní tvůrčí prací.<br/>
        (3 ) Spolupůvodci mají právo na patent v rozsahu, v jakém se podíleli na vytvoření vynálezu.<br/>
        <br/>
        <br/>
        Zajímavé je to, že české právní normy (stejně jako většina norem ostatních zemí) neobsahují definici, co to
        vynález je. „Patentový zákon“ popisuje pouze podmínky, za kterých může být vynálezu udělen patent.<br/>
        <br/>
        V první řadě je ale užitečné vědět, co považovat za vynálezy nelze. Zapamatujme si, že mezi vynálezy nepatří dle
        české legislativy například vědecké teorie a matematické metody, plány, pravidla a způsoby vykonávání duševní
        činnosti, hraní her či počítačové programy. Dále vynález nesmí být v rozporu s veřejným pořádkem nebo dobrými
        mravy.<br/>
        <br/>
        Aby byl na vynález udělen patent, musí splňovat tři následující podmínky: musí být nový, musí být výsledkem
        vynálezecké činnosti a musí být průmyslově využitelný.<br/>
        <br/>
        Průmyslová využitelnost znamená, že by se myšlenka či technologie měla dát vyrábět či využít a měla by fungovat.
        Aby se například nejednalo o perpetuum mobile, jehož sestrojení bylo a stále je snem mnoha vynálezců.<br/>
        <br/>
        Vynálezecká činnost znamená, že řešení by nemělo být běžnému smrtelníku zřejmé – mělo by se jednat o velmi
        významný posun ve stavu techniky. Důležité je ale zmínit, že se nejedná o množství práce, které vynálezce na
        vynalézání nového řešení strávil. Velmi často se totiž může jednat o docela krátký moment, který nazýváme „Flash
        of Genius“.<br/>
        <br/>
        Bezesporu nejdůležitější podmínkou je podmínka novosti – to znamená, že dané řešení, daný nápad či technologie
        musí být opravdu nová. Respektive, podstata vynálezu nesmí být žádným způsobem zveřejněná či veřejně známá. Je
        tedy velmi důležité se seznámit se stavem techniky v oboru, ve kterém působíte. A to nikoliv pouze v České
        republice, ale po celém světě. Jako zdroj rešerší slouží především patentové databáze. Ale také odborné či
        profesní časopisy, materiály z výstav či konferencí nebo údaje uveřejněné na webových stránkách. Pokud zjistíme,
        že naše řešení už někdo někde popsal, zveřejnil či dokonce patentoval, pak se nejedná o řešení nové, a tudíž ani
        o vynález.<br/>
        <br/>
        S patentovými rešeršemi je dobré začít v databázích, které spravuje Úřad průmyslového vlastnictví (ÚPV). V
        databázi patentů a užitných vzorů najdete například přihlášky vynálezů zveřejněné od roku 1991 a evropské
        patenty platné na českém území. Dále můžete využít databáze Evropského patentového úřadu (EPO) ESPACENET,
        Světové organizace duševního vlastnictví (WIPO) PATENTOSCOPE nebo vyhledávací systém Úřadu Evropské unie pro
        duševní vlastnictví (EUIPO) eSearch plus. Díky rešerši zjistíte, zda jste opravdu majiteli unikátního a nového
        řešení.<br/>
        <br/>
        Velmi důležitou otázkou je to, kdo vůbec s myšlenkou přišel – kdo je vynálezce neboli původcem vynálezu. Odpověď
        na to, kdo je původcem vynálezu, najdeme v § 8 patentového zákona, který říká, že původcem vynálezu je ten, kdo
        jej vytvořil vlastní tvůrčí prací. A dále to, že spolupůvodci mají právo na patent v rozsahu, v jakém se
        podíleli na vytvoření vynálezu.<br/>
        <br/>
        U původcovství mohou vznikat určité nejasnosti ohledně podílu tvůrčí práce dalších osob (například školitele či
        dalších studentů u skupinové práce) v rámci nového řešení – vynálezu.<br/>
        <br/>
        Vzhledem k tomu, že jsme na vysoké škole, tak je pro nás velmi důležité, jaký je vztah vysoké školy k tomu, kdo
        s nějakou myšlenkou přijde. V podstatě můžeme rozlišit dvě základní situace. První je ta, kdy osoba nemá k
        vysoké škole žádný pracovně-právní vztah – tj. jedná se především o studenty. Druhou situací je ta, když je
        osoba v pracovně-právním vztahu.<br/>
        <br/>
        Podívejme se tedy nejdříve na studenty. V případě, že student, který nemá vůči žádné součásti vysoké školy
        pracovně-právní vztah, přijde v rámci vzdělávání na nějaké řešení, potom je v naprosté většině případů jediným
        původcem či autorem tohoto řešení. Nemá v podstatě žádné závazky vůči vyučujícím ani vysoké škole – se získanými
        poznatky a nápady může nakládat dle svého uvážení – může je publikovat, chránit nástroji průmyslově-právní
        ochrany, může je využít pro účely své další podnikatelské činností – například vložit jako nepeněžitý vklad –
        oceněné know-how – do nově založené společnosti. Pokud se student podílel sám na vzniku nového řešení, pak si s
        ním může nakládat dle svého uvážení. Situace se může drobně lišit, jestliže je nalezené řešení součástí tzv.
        školního díla – tj. bakalářské, diplomové či doktorské práce.<br/>
        <br/>
        V případě bakalářské, magisterské či disertační práce by se z podstaty mělo jednat o původní dílo autora –
        pomineme-li případy plagiátorství. Autor práce prohlašuje, že dílo psal samostatně pouze s využitím uvedené
        literatury a zdrojů. Nikdo jiný tedy nemůže být autorem tohoto díla. Některé další podrobnosti o závěrečných
        pracích upravuje zákon č . 111/1998 Sb., o vysokých školách v § 47b, a to především způsob zveřejňování.<br/>
        § 47b<br/>
        Zveřejňování závěrečných prací<br/>
        (1 ) Vysoká škola nevýdělečně zveřejňuje bakalářské, diplomové, disertační a rigorózní práce, u kterých proběhla
        obhajoba, včetně posudků oponentů a záznamu o průběhu a výsledku obhajoby prostřednictvím databáze
        kvalifikačních prací, kterou spravuje. Způsob zveřejnění stanoví vnitřní předpis vysoké školy. Vysoká škola
        disertační práci nezveřejňuje, byla-li již zveřejněna jiným způsobem.<br/>
        (2 ) Bakalářské, diplomové, disertační a rigorózní práce odevzdané uchazečem k obhajobě musí být též nejméně pět
        pracovních dnů před konáním obhajoby zveřejněny k nahlížení veřejnosti v místě určeném vnitřním předpisem vysoké
        školy nebo není-li tak určeno, v místě pracoviště vysoké školy, kde se má konat obhajoba práce. Každý si může ze
        zveřejněné práce pořizovat na své náklady výpisy, opisy nebo rozmnoženiny.<br/>
        (3 ) Platí, že odevzdáním práce autor souhlasí se zveřejněním své práce podle tohoto zákona, bez ohledu na
        výsledek obhajoby.<br/>
        (4 ) Vysoká škola může odložit zveřejnění bakalářské, diplomové, disertační a rigorózní práce nebo jejich části,
        a to po dobu trvání překážky pro zveřejnění31), nejdéle však na dobu 3 let. Informace o odložení zveřejnění musí
        být spolu s odůvodněním zveřejněna na stejném místě, kde jsou zveřejňovány bakalářské, diplomové, disertační a
        rigorózní práce. Vysoká škola zašle bez zbytečného odkladu po obhájení bakalářské, diplomové, disertační a
        rigorózní práce, jíž se týká odklad zveřejnění podle věty první, jeden výtisk práce k uchování
        ministerstvu.<br/>
        Autorský zákon, tj. zákon č . 121/2000 Sb., zmiňuje v §60 některé podrobnosti o školním díle, které se týkají
        především možnosti užití školního díla autorem či školou a také případné úhrady nákladů v případě, že autor
        školního díla bude mít z udělení licence třetí osobě výdělek.<br/>
        § 60<br/>
        Školní dílo<br/>
        (1 ) Škola nebo školské či vzdělávací zařízení mají za obvyklých podmínek právo na uzavření licenční smlouvy o
        užití školního díla (§ 35 odst. 3 ). Odpírá-li autor takového díla udělit svolení bez závažného důvodu, mohou se
        tyto osoby domáhat nahrazení chybějícího projevu jeho vůle u soudu. Ustanovení § 35 odst. 3 zůstává
        nedotčeno.<br/>
        (2 ) Není-li sjednáno jinak, může autor školního díla své dílo užít či poskytnout jinému licenci, není-li to v
        rozporu s oprávněnými zájmy školy nebo školského či vzdělávacího zařízení.<br/>
        (3 ) Škola nebo školské či vzdělávací zařízení jsou oprávněny požadovat, aby jim autor školního díla z výdělku
        jím dosaženého v souvislosti s užitím díla či poskytnutím licence podle odstavce 2 přiměřeně přispěl na úhradu
        nákladů, které na vytvoření díla vynaložily, a to podle okolností až do jejich skutečné výše; přitom se
        přihlédne k výši výdělku dosaženého školou nebo školským či vzdělávacím zařízením z užití školního díla podle
        odstavce 1 .<br/>
        <br/>
        Druhou situací je, že na nějakou myšlenku, která je způsobilá k průmyslově právní ochraně, přijde zaměstnanec.
        Patentový zákon pamatuje na situace, kdy zaměstnanec tvůrčí činností dospěje k vynálezu v rámci své pracovní
        činnosti. Zákon tuto situaci nazývá podnikový vynález a popisuje ho §9 .<br/>
        Podnikový vynález<br/>
        § 9<br/>
        (1 ) Vytvořil-li původce vynález ke splnění úkolu z pracovního poměru, z členského nebo jiného obdobného
        pracovněprávního vztahu (dále jen "pracovní poměr") k zaměstnavateli, přechází právo na patent na
        zaměstnavatele, není-li smlouvou stanoveno jinak. Právo na původcovství tím není dotčeno.<br/>
        (2 ) Původce, který vytvořil vynález v pracovním poměru, je povinen zaměstnavatele o této skutečnosti neprodleně
        písemně vyrozumět a předat mu podklady potřebné k posouzení vynálezu.<br/>
        (3 ) Neuplatní-li zaměstnavatel ve lhůtě tří měsíců od vyrozumění podle ustanovení odstavce 2 vůči původci právo
        na patent, přechází toto právo zpět na původce. Zaměstnavatel i původce jsou v této lhůtě povinni zachovávat
        vůči třetím osobám o vynálezu mlčenlivost.<br/>
        (4 ) Původce, který vytvořil vynález v pracovním poměru, na nějž zaměstnavatel uplatnil právo na patent, má
        právo vůči zaměstnavateli na přiměřenou odměnu. Pro její výši je rozhodný technický a hospodářský význam
        vynálezu a přínos dosažený jeho možným využitím nebo jiným uplatněním, přičemž se přihlíží k materiálnímu podílu
        zaměstnavatele na vytvoření vynálezu a k rozsahu pracovních úkolů původce. Dostane-li se již vyplacená odměna do
        zjevného nepoměru s přínosem dosaženým pozdějším využitím nebo jiným uplatněním vynálezu, má původce právo na
        dodatečné vypořádání.<br/>
        <br/>
        Možná by bylo více odpovídající, kdybychom hovořili spíše o „zaměstnaneckém“ vynálezu – ostatně se jedná o
        vynálezy, které byly dle zákona vytvořeny ke splnění úkolu z pracovního poměru, členského či jiného obdobného
        pracovně právního vztahu k zaměstnavateli. Vztahem k zaměstnavateli se míní pracovní úvazek (klidně částečný),
        dohody o pracovní činnosti či dohody o provedení práce.<br/>
        <br/>
        Kdokoliv, kdo má uzavřenou nějakou pracovní smlouvu na ČVUT či jeho součásti, je v souladu s legislativou
        povinen zaměstnavatele neprodleně informovat o skutečnosti, že je původcem vynálezu, písemně vyrozumět a předat
        podklady k jeho posouzení. Podrobnosti jsou upraveny ve vnitřních předpisech. Na Českém vysokém učení technickém
        v Praze se jedná o Příkaz rektora č . 20/ 2020 „Pro ochranu, správu a využití duševního vlastnictví ČVUT v
        Praze“.
        <br/>
        <br/>
    </BasePdf>
};
export default InnovativeModulePdf;
